export function normalizeGenreValue(value) {
  if (!value) return "";

  return decodeURIComponent(String(value))
    .trim()
    .replace(/\\+$/, "")
    .replace(/\s+/g, " ")
    .toLowerCase();
}

export function getTargetKey(target) {
  return `${target?.pageType || "homepage"}:${normalizeGenreValue(
    target?.genreSlug || ""
  )}`;
}

export function buildPageTargetPayload(target) {
  if (target?.pageType === "genre" && target?.genreSlug) {
    return {
      pageType: "genre",
      genreSlug: normalizeGenreValue(target.genreSlug),
    };
  }

  return {
    pageType: "homepage",
  };
}

export function getTargetDisplayLabel(target) {
  if (!target) return "Homepage";
  return target.label || (target.pageType === "genre" && target.genreSlug
    ? `Genre / ${target.genreSlug}`
    : "Homepage");
}
